import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=5a0eeae7&scoped=true&"
import script from "./Discuss.vue?vue&type=script&lang=js&"
export * from "./Discuss.vue?vue&type=script&lang=js&"
import style0 from "./Discuss.vue?vue&type=style&index=0&id=5a0eeae7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0eeae7",
  null
  
)

export default component.exports